import { tracked } from '@glimmer/tracking';

import type { GeneralComponentClass } from 'webapp-types';

import InfolayerTypeViewBoardComponent from 'webapp/components/infolayer/type-view-board';

import type Board from 'webapp/models-custom/board';
import type {
	ConstructorData as BaseConstructorData,
	onCloseFn,
} from 'webapp/models-custom/infolayer-item/base';
import InfolayerItemBase, { EXPIRE_ERROR } from 'webapp/models-custom/infolayer-item/base';
import { Type as GeneralType } from 'webapp/models-custom/infolayer-item/general';

export interface ConstructorData extends BaseConstructorData {
	board: Board;
}

export default class InfolayerItemViewBoard extends InfolayerItemBase {
	componentClass: GeneralComponentClass = InfolayerTypeViewBoardComponent;

	@tracked board: Board;
	@tracked status = GeneralType.LOADING;
	@tracked errorText = '';
	@tracked successfullyMigratedSourcesCount = 0;
	@tracked sourceCount = 0;

	constructor(data: ConstructorData, onClose: onCloseFn) {
		super(data, onClose);

		this.board = data.board;
	}

	override get classes(): string {
		return (
			super.classes +
			' ' +
			this.status +
			(this.hasMigrationHappened ? ' ok--no-migration' : '')
		);
	}

	get isLoading() {
		return this.status === GeneralType.LOADING;
	}

	get isError() {
		return this.status === GeneralType.ERROR;
	}

	get hasMigrationHappened() {
		return this.successfullyMigratedSourcesCount === 0;
	}

	setError(errorText = '') {
		this.status = GeneralType.ERROR;
		this.errorText = errorText || 'Unknown error';
		this.expire(EXPIRE_ERROR);
	}

	setDone(
		recievedBoard: Board,
		successfullyMigratedSourcesCount: number,
		unsuccessfullyMigratedSourcesCount: number,
	) {
		this.status = GeneralType.OK;
		this.board = recievedBoard;
		this.successfullyMigratedSourcesCount = successfullyMigratedSourcesCount;
		this.sourceCount = successfullyMigratedSourcesCount + unsuccessfullyMigratedSourcesCount;
		this.expire(null); // don't expire
	}

	checkIfDuplicated(items: InfolayerItemBase[]): boolean {
		return items.some(
			(item) =>
				item instanceof InfolayerItemViewBoard &&
				item.errorText === this.errorText &&
				this.isError,
		);
	}
}
